<template>
	<div class="more-box" :class="headerSpace > 0 ? 'moreOrderTop' : 'moreTop' ">
		<div class="more-item" @click="$router.push({name:'HomeIndex'})"><i class="iconfont">&#xe6b2;</i>{{ $t('menu.home') }}</div>
		<div class="more-item" @click="$router.push({name:'HomeSearch'})" v-if="routerName !== 'HomeGoodsdetail'"><i class="iconfont">&#xe61f;</i>{{ $t('menu.search') }}</div>
		<!-- <div class="more-item" @click="$router.push({name:'HomeCart'})" v-if="routerName !== 'HomeGoodsdetail'"><i class="iconfont">&#xe6ae;</i>购物车</div> -->
<!--         <div class="more-item" @click="$router.push({name:'MemberIndex'})"><i class="iconfont">&#xe6b4;</i>我的商城</div>
		<div class="more-item" @click="$router.push({name:'SellerIndex'})" v-if="routerName !== 'HomeGoodsdetail'"><i class="iconfont">&#xe644;</i>商家登录</div>
		<div class="more-item" @click="$router.push({name:'FuwuManageInfo'})" v-if="routerName !== 'HomeGoodsdetail'"><i class="iconfont">&#xe686;</i>服务机构</div>
		<div class="more-item" @click="$router.push({name:'DistributorHome'})" v-if="routerName !== 'HomeGoodsdetail'"><i class="iconfont">&#xe6a6;</i>配送员登录</div> -->
		<div class="more-item" @click.stop="onShare"><i class="iconfont">&#xe625;</i>{{ $t('menu.share') }}</div>
		<i class="arrow"></i>

		<mt-popup v-model="shareVisible" position="bottom" class="common-popup-wrapper">
			<div class="common-header-wrap">
				<mt-header :title="$t('share.to')" class="common-header">
					<mt-button slot="left" icon="back" @click="shareVisible=false"></mt-button>
				</mt-header>
			</div>
			<div class="common-popup-content">
				<div class="share-list">
					<div class="share-item copy" @click="showLink">{{ $t('share.copy') }}</div>
					<div class="share-item goods" v-if="goods_id" @click="goodsPoster">{{ $t('share.poster') }}</div>
				</div>
			</div>
			<div class="weixin-share-wrapper" :style="getWrapperStyle" v-if="weixinShareImage" @click="weixinShareImage=false"><img class="weixin-share" src="../assets/image/weixin-share.png"></div>
		</mt-popup>

		<mt-popup v-model="copyVisible" class="copy-wrapper">
			<div class="title">{{ $t('share.copy_manual') }}</div>
			<input type="text" :value="copyLink" onfocus="this.select()" >

		</mt-popup>
		<mt-popup v-model="popupVisible">
			<img :src="posterUrl" :style="getBannerStyle">
		</mt-popup>
	</div>
</template>

<script>
import { Toast } from 'mint-ui'
import { goodsPoster } from '../api/member'
import { getWechatShare } from '../api/common'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
	name: 'HeaderMore',
	data () {
		return {
			posterUrl:'',
			popupVisible:false,
			shareVisible: false,
			weixinShareImage: false,
			copyVisible: false,
			uniapp: 0
		}
	},
	components: {

	},
	created: function () {
	},
	props: {
		goods_id: {},
		share_info: {},
		share_message: {
			type: String,
			default: ''
		}
	},
	computed: {
		getBannerStyle: function () {
			const { width,height } = window.screen
			let itemWidth = width-20
			let itemHeight = height-20
			return {
				maxWidth: itemWidth + 'px',
				maxHeight: itemHeight + 'px'
			}
		},
		...mapState({
			user: state => state.member.info,
			config: state => state.config.config,
			orderNum: (state) => state.member.orderNum
		}),
		headerSpace() {
			return this.orderNum > 0 && this.routerName != 'HomeGoodsdetail'
		},
		routerName () {
			return this.$route.name
		},
		copyLink () {
			var link = ''
			if (this.share_info && this.share_info.link) {
				link = this.share_info.link
			} else {
				link = window.location.href
			}
			if (this.user) {
				if (link.indexOf('?') != -1) {
					link += '&'
				} else {
					link += '?'
				}
				link += 'inviter_id=' + this.user.member_id
			}

			return link
		},
		getWrapperStyle: function () {
			const { width, height } = window.screen
			return {
				width: width + 'px',
				height: height + 'px'
			}
		}
	},

	methods: {
		...mapActions([
			'openInviteFriendsModal'
		]),
		goodsPoster(){
			goodsPoster(this.goods_id).then(res=>{
				this.posterUrl=res.result.goods_poster
				this.popupVisible=true
			}).catch(error=>{
				Toast(error.message)
			})
		},
		showLink () {
			if (window.clipboardData) {
				window.clipboardData.clearData()
				window.clipboardData.setData('Text', this.copyLink)
				Toast(this.$t('share.copy_successful'))
			} else {
				this.copyVisible = true
			}
		},
		async onShare () {
			if (!this.share_message) {
				this.openInviteFriendsModal()
			}

			if (!window.nativePostMessage || !this.share_message) {
				return
			}

			try {
				if (!navigator.share) {
					throw new Error('Web Share API not supported')
				}
				await navigator.share({
					title: this.$t('invite_friends.share_my_invitation_code'),
					text: this.share_message
				})
			} catch (err) {
				this.$alert.error(this.$t('invite_friends.failed_to_share_copy_your_invitation_code'))
				console.error(err)
			}
		}
	}
}
</script>

<style scoped>
	.moreTop {
		top:2.2rem;
	}
	.moreOrderTop {
		top: 6rem
	}
	.more-box{background:#000;position:absolute;width:5.6rem;z-index:1000;right:0.3rem;top:3rem;border-radius:0.2rem;}
	.more-item{border-bottom: 1px solid hsla(0,0%,100%,.2);height: 2rem;line-height: 2rem;list-style: none outside none;color:#fff;font-size:0.7rem;}
	.more-item i{margin:0 0.4rem;}
	.arrow {
		position:absolute;
		display: block;
		right:0.2rem;
		top:-0.7rem;
		width: 0;
		height: 0;
		margin-right: 0.45rem;
		font-size: 0;
		line-height: 0;
		border-width: 0.4rem;
		border-color: transparent transparent rgb(0,0,0) transparent;
		border-style: dashed dashed solid dashed;
	}
	.common-popup-wrapper{height:10rem;overflow: visible}
	.more-box .share-list{display:flex}
	.more-box .share-list .share-item{height: 3rem;margin:1rem 0.8rem;width:2.5rem;padding-left:0;background: none;text-align:center;color: #333;font-size:0.6rem;}
	.more-box .share-list .share-item:before{font-family: "iconfont";content:'';display:block;border-radius:50%;width:2rem;height:2rem;line-height:2rem;text-align:center;font-size:1.2rem;color:#fff;background: red;margin:0 auto;margin-bottom:.25rem}
	.more-box .share-list .share-item.weixin:before{content:"\e647";background:#C71585;}
	.more-box .share-list .share-item.copy:before{content:"\e64b";background:#228B22;}
	.more-box .share-list .share-item.goods:before{content:"\e6dd";background:#f44336;}
	.more-box .weixin-share-wrapper{position: absolute;bottom:0;left:0;text-align: right}
	.more-box .weixin-share{height:10rem;}
	.copy-wrapper{padding:1rem;}
	.copy-wrapper input{height:1.5rem;line-height:1.5rem;padding:0 .2rem;width:12rem;border:1px solid #e1e1e1}
	.copy-wrapper .title{font-size:.6rem;text-align: center;margin-bottom:.5rem;}
</style>
